import './style.css';
function ShoesCard({ item }) {
    return (
        <>
            <div className="container">
                <div className="row">


                    {
                        item.map((db) => {
                            let {Id,img,name,price,color,brand,catagary} =db
                            return (
                                <>
                                    <div className="col-md-4">
                                        <div className="card" >
                                            <div className="card-header"><h3>Id :- <span>{Id}</span></h3></div>
                                            <img className="card-img-top" src={img} alt="Card image cap" />
                                            <div className="card-body">
                                                <p>Name :- {name} </p>
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Price</th>
                                                            <th scope="col">Color</th>
                                                            <th scope="col">Brand</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{price }</td>
                                                            <td>{color }</td>
                                                            <td>{brand }</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <h6>Catagary :- {db.catagary}</h6>
            
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        }
                        )
                    }




                </div>
            </div>
        </>
    )
}

export default ShoesCard;